
import { Component, Vue } from 'vue-property-decorator';
import { BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseText }
})
export default class ProductsToWithdrawHeader extends Vue {}
